export default __webpack_public_path__ + "static/media/post1.34b8c52c.png";